import { track } from '@/common/monitoring/heap';

export const trackSubmitClick = () => {
  track({
    eventName: 'TicketSearchFormSubmission',
    eventData: {
      eventType: 'SearchTicketsForm',
      eventLabel: 'FindTicketsSearchTicketsForm',
      eventAction: 'SubmitButtonClick',
    },
  });
};

export const trackTicketsFound = () => {
  track({
    eventName: 'TicketsFound',
    eventData: {
      eventType: 'SearchTicketsForm',
      eventLabel: 'FindTicketsSearchTicketsForm',
      eventAction: 'EmailUnknownTicketsFound',
    },
  });
};

export const trackTicketsNotFound = () => {
  track({
    eventName: 'TicketsNotFound',
    eventData: {
      eventType: 'SearchTicketsForm',
      eventLabel: 'FindTicketsSearchTicketsForm',
      eventAction: 'EmailUnknownTicketsNotFound',
    },
  });
};
